import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import emissionGasIcon from "../../../../../assets/design-revamp-company/company-detail-headers/emission-gasses-icon.svg";
import { useTranslation } from "react-i18next";
import { getEmissionGassesTotal } from "../../../../../apis/Business/emissionGassesApi";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import stationaryGraphic from "../../../../../assets/design-revamp-company/company-detail-headers/stationary-graphic-icon.svg";

const EmissionGasIcon = () => (
  <img src={emissionGasIcon} alt="Water Icon" width={76} height={76} />
);

const EmissionGasHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjGasses, setTotalObjGasses] = useState([]);
  const [systemBoundaryGasses, setSystemBoundaryGasses] = useState("");
  useEffect(() => {
    getEmissionGassesTotal({
      businessId: businessId,
      setTotalObj: setTotalObjGasses,
      setSystemBoundaryGasses: setSystemBoundaryGasses,
    });
  }, [businessId]);

  return (
    <CategoryComponent
      show={show}
      className={`emission-gas-category ${className || ""}`}
      leftBoxProps={{
        icon: <EmissionGasIcon />,
        title: t("EMISSION_GAS"),
        description: t("EMISSION_GAS_INTRO"),
        scopes: [{ scope: "Scope 1", filled: true }],
        graphicIcons: [{ icon: stationaryGraphic }],
        showInfoIcon: true,
        infoText: t("TIP_EMISSION_GAS"),
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: t("EXPENSES"),
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalObjGasses,
                      totalObjGasses?.total_expenses
                    ),
                  },
                ],
              },
              {
                subtitle: `${t("EMISSIONS")} ${handleToFixedNum(
                  totalObjGasses,
                  totalObjGasses?.total_emissions
                )} (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjGasses,
                      totalObjGasses.total_scope_1
                    ),
                    scopes: ["Scope 1"],
                  },

                  {
                    value: handleToFixedNum(
                      totalObjGasses,
                      totalObjGasses.total_scope_3
                    ),
                    scopes: ["S:3, C:8"],
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjGasses?.updated_at
          ? formatDate(totalObjGasses?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      systemBoundaryProps={{
        systemBoundary: systemBoundaryGasses,
        setSystemBoundary: setSystemBoundaryGasses,
        businessId: businessId,
        totalObjCategory: totalObjGasses.category_name,
      }}
      {...props}
    />
  );
};

export default EmissionGasHeader;
